import { Text } from "@hackthenorth/north";
import React from "react";
import styled from "styled-components";

import { Modal } from "src/shared/components";
import { HelpDeskMap } from "src/static/img";

import FooterActions from "../../../../footerActions";

interface HelpDeskModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const HelpDeskModal: React.FC<HelpDeskModalProps> = ({ isOpen, onClose }) => {
  return (
    <Modal title="How to get to Help Desk" isOpen={isOpen}>
      <ContentWrapper>
        <SubtitleWrapper>
          <SubtitleBold mods="p">
            Help Desk is located by the main entrance on the first floor!
          </SubtitleBold>
          <Text mods="p">Refer to this map for more details</Text>
        </SubtitleWrapper>
        <MapImage src={HelpDeskMap} alt="Help Desk Map" />
      </ContentWrapper>
      <BottomActionContainer>
        <FooterActions onConfirm={onClose} confirmText="See you there!" />
      </BottomActionContainer>
    </Modal>
  );
};

export default HelpDeskModal;

const BottomActionContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
  padding: 0 16px;
`;

const SubtitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const SubtitleBold = styled(Text)`
  font-weight: 700;
`;

const MapImage = styled.img`
  width: 547px;
  height: auto;
`;
